export const checkOfferTimingValid = (enhancedOffer) => {
  const now = (new Date()).getTime() / 1000;
  // skip already expired offers, non-time-limited offers come with 0
  if (enhancedOffer.endDateTime !== 0 && enhancedOffer.endDateTime < now) {
    return false;
  }
  return true;
};
